import React from "react";
import Dialog from "../dialog/dialog";
import Svg from "../svg/index";
import ScrollBox from "../scroll/scrollBox2.0"
import TipStyle from "./style";

//全局loading   大loading
function Message(props) {

    /*
     * this.props.open
     * this.props.type
     *      submitting/loading   不需要传 btnText 和cancelBtnText
     *                           title    传的是标题说明  不传就不显示   如提交中  加载中(必填)
     *
     *      hint    cancelBtnText传的是取消按钮的说明 如返回 取消 默认取消
     *              btnText  传的是确认的按钮的说明  如提交 确认   默认确认
     *              title    传的是标题说明  不传就不显示
     *              content   补充说明文字
     *              this.props.handleClose   是cancelBtnText对应按钮的方法 只在type为hint的时候传
     *              this.props.handleFn      是btnText对应的按钮的方法
     *
     *
     *   fail       btnText  传的是确认的按钮的说明  如提交 确认   默认确认
     *              title    传的是标题说明  不传就不显示
     *              content   补充说明文字
     *              this.props.handleFn      是btnText对应的按钮的方法
     *
     *   success     title    传的是标题说明  不传就不显示
     *              content   补充说明文字
     *              this.props.handleFn      是btnText对应的按钮的方法
     *
     *
     *
     * */

    const contentStyle = { width: `${props.width ? props.width : "40.25rem"}`, background: "#fff", maxWidth: '120rem', zIndex: "123456" };
    const bodyStyle = { padding: '0', width: '100%',};
    const bgStyle = { zIndex: "12345" };
    const handleClose = () => {
        props.handleClose(props.remarks)
    }
    const submitFn = () => {
        props.submitFn(props.remarks)
    }
    // Object.assign(TipStyle.tipsBoxShow,{height:`${props.height?props.height:null}`})
    TipStyle.tipsBoxShow
    // props.height?
    return (
        <Dialog open={props.open}
            bgStyle={bgStyle}
            contentStyle={contentStyle}
            bodyStyle={bodyStyle}>
            <div style={Object.assign(props.open ? TipStyle.tipsBoxShow : TipStyle.tipsBoxHide)}>
                {/*图标*/}
                <div style={TipStyle.svgBox}>
                    <Svg type="Hint" width="3.75rem" height="3.75rem" fill="#ffbe62" />
                </div>
                {props.title ? <p style={TipStyle.title}>{props.title}</p> : null}

                <ScrollBox
                    width={`${props.width ? props.width : '40.25rem'}`}
                    maxHeight={`${props.contentHeight ? props.contentHeight : '10rem'}`}
                >
                    <div
                        style={TipStyle.body}>
                        {props.content ? <p style={TipStyle.content}>{props.content}</p> : null}
                    </div>
                </ScrollBox>

                <div style={props.open ? TipStyle.buttonBoxOn : TipStyle.buttonBoxOff}>
                    {props.btnText ?
                        <p style={TipStyle.hintLeft}
                            onClick={submitFn}>{props.btnText}</p>
                        : null
                    }
                    <p style={props.btnText ? TipStyle.hintRight : TipStyle.hint}
                        onClick={handleClose}>
                        {props.cancelBtnText ? props.cancelBtnText : '取消'}
                    </p>
                </div>


            </div>
        </Dialog>

    )
}

export default Message;